import axios, { AxiosRequestConfig } from 'axios';
import { UpdateUserCredentials } from './types';
import { clearSessionCredentials } from '../../../../globalFunctions';
import { NavigateFunction } from 'react-router-dom';

export const updateUser = async (
    token: string,
    navigate: NavigateFunction,
    credentials: UpdateUserCredentials
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/trilogic/user/${credentials.id}`,
            credentials,
            requestConfig
        );

        return response.data.user;
    } catch (error: any) {
        const response = {
            message: 'Ocorreu um erro durante a sua atualização cadastral',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
            clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return response;
        }
    }
};
